export const OFFER_STEPS = {
  address: 0,
  buyer: 1,
};
